import { httpRequest } from "@services/http";

export class CommandGetOAuthUrl {
  async run(resourceId: number): Promise<{ auth_url: string }> {
    try {
      return await httpRequest<{ auth_url: string }>(
        `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content_network/network_accounts/network_resources/${resourceId}/oauth/start`,
        { method: "GET", auth: true, headers: { Accept: "application/json" } },
      );
    } catch (error) {
      console.error("Error getting OAuth URL:", error);
      throw error;
    }
  }
}
